import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import styles from './Pagination.module.css';

interface Props {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

const Pagination: React.FC<Props> = ({ page, totalPages, onChange }) => {
  if (totalPages <= 1) return null;

  return (
    <div className={styles.wrap}>
      <button className={styles.navBtn} disabled={page === 1} onClick={() => onChange(page - 1)}>
        <FiChevronLeft /> Prev
      </button>
      <span className={styles.pageInfo}>Page {page} of {totalPages}</span>
      <button className={styles.navBtn} disabled={page === totalPages} onClick={() => onChange(page + 1)}>
        Next <FiChevronRight />
      </button>
    </div>
  );
};

export default Pagination;
